"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import { on, find,findAll, findAllIn,findIn} from '@elements/dom-utils';
import axios from "axios";
import asyncAppend from "@elements/async-append";
import Modal from 'bootstrap/js/dist/modal';
export function init () {
    console.log('weather-modal init');
    let modal = find('.js-ajax-modal');
    let requestBtn = findAll('.js-ajax-modal__btn');

    requestBtn.forEach((btn) => {
        on('click', () =>{
            let action = btn.getAttribute('data-action');
            console.log(action);
            console.log(modal);
            let pendingRequest = axios({
                method: 'POST',
                url: action,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });

            asyncAppend({
                target: findAllIn('.js-ajax-modal__result', modal),
                loading: findAllIn('.js-ajax-modal__loading', modal)
            },  pendingRequest.then((x) => {
                return x.data;
            }));

        }, btn);
    });
}